import { useAppSelector } from '~/redux/hooks'

import { type Role } from '../types/user'

export function useRole() {
  const user = useAppSelector(state => {
    if (!state.user) throw new Error('No user')
    return state.user
  })
  /**
   * Check if the current user has any of the roles in the list
   */
  function userHasAnyRole(roles: Role[]): boolean {
    if (Array.isArray(roles) && roles.length > 0) {
      return roles.some(role => role === user.role)
    }

    return false
  }

  return { userHasAnyRole }
}
